import React from "react";
import {FormattedMessage} from "react-intl";

import Analytics from './../../analytics';
import store from "../../store";
import {UserPopupTypes} from "../visComponents/constants";

const LockedView = (props) => {
  const fabricatorSettings = store.getState().fabricatorState.settings;
  const getQuoteEnabled = fabricatorSettings.enableQuote;
  return (
    <div className="lock">
      <button className="lock-close ui-close" onClick={() => Analytics.sendClickEvent('lock-close') && props.setActiveFeature(null)}/>
      <div className="lock-content">
        <span className="lock-icon"/>
        <p className="lock-text">
          <FormattedMessage id="lockedScreen.itemLocked"/>
        </p>
        <button className="lock-button ui-button3 ui-button3--green"
                onClick={() => Analytics.sendClickEvent(getQuoteEnabled ? "get-quote" : "unlock-button") && props.handleUserLoginClick(
                  getQuoteEnabled ? UserPopupTypes.GetQuote : UserPopupTypes.Unlock
                )}>
          <FormattedMessage id={getQuoteEnabled ? "lockedScreen.getQuoteButton" : "lockedScreen.unlockNowButton"}/>
        </button>
      </div>
    </div>
  )
};

LockedView.displayName = 'LockedView';

export default LockedView;

